import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'readers';

class Readers {
  async getUsingQueryFilter(queryFilter) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ name: queryFilter });

    const response = await http.get(`/${controllerName}${queryString}`);
    const items = response.data && response.data.items;

    return items;
  }

  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`);
  }

  create(reader) {
    return http.post(`/${controllerName}`, reader);
  }

  delete(id) {
    return http.delete(`/${controllerName}/${id}`);
  }

  update(id, reader) {
    return http.put(`/${controllerName}/${id}`, reader);
  }
}

export const readers = new Readers();
